import React from 'react';
import { useReveal } from '../lib/useReveal';
const AUDIENCE = [{
  emoji: '🔄',
  text: 'Para vos si sentís que repetís siempre los mismos patrones'
}, {
  emoji: '💬',
  text: 'Para vos si querés entender el mensaje detrás de tus síntomas'
}, {
  emoji: '🤝',
  text: 'Para vos si trabajás acompañando personas y querés sumar una herramienta poderosa'
}, {
  emoji: '🏥',
  text: 'Para vos si sentís que la medicina tradicional no alcanza para explicar lo que vivís'
}];
export function TargetAudienceSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-180">
      <div className="container mx-auto max-w-4xl" data-id="element-181">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-182">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#eab308] mb-10 text-center" data-id="element-183">
            ¿Para quién es esto?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
            {AUDIENCE.map((item, idx) => <div key={idx} className="bg-[#111111] rounded-xl p-6 border border-[#eab308]/10 hover:border-[#eab308]/30 transition-colors" data-id="element-185">
                <div className="text-4xl mb-4" data-id="element-186">{item.emoji}</div>
                <p className="text-gray-200 text-lg leading-relaxed" data-id="element-187">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}